import { Link } from 'components/Atoms/Link'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'
import { WsbStaticLeftContentCSS } from './WsbStaticLeftContentCSS.styled'
import { useLayoutV3State } from 'hooks/useLayoutV3State'

export const WsbStaticLeftContent = () => {
  const { isOpenLeftPanel } = useLayoutV3State()
  return (
    <WsbStaticLeftContentCSS>
      <SingleContentToggle
        noWrapper
        toggle={isOpenLeftPanel}
        trueContent={
          <>
            <div className='static_summary'>
              <summary>
                <h1>
                  <div className='icon'></div>
                  Degen News
                </h1>
              </summary>

              <summary className='static'>
                <div className='events_content'></div>
              </summary>
            </div>

            <Link className='short_term_prediction' href='https://www.reddit.com/r/wallstreetbets/'>
              <summary>
                <h1>
                  <div className='icon'></div>
                  r/wallstreetbets
                </h1>
                <div className='external_link_icon'></div>
              </summary>
            </Link>
          </>
        }
        falseContent={
          <>
            <div className='static_summary close'>
              <summary>
                <h1>
                  <div className='icon'></div>
                </h1>
              </summary>
            </div>

            <details className='short_term_prediction close'>
              <summary>
                <h1>
                  <div className='icon'></div>
                </h1>
              </summary>
            </details>
          </>
        }
      />
    </WsbStaticLeftContentCSS>
  )
}
